import React, { useState } from 'react';
import { Field, Form } from 'react-final-form';
import { Grid } from '@mui/material';
import TextFieldAdapter from '../../FinalFormAdapters/TextFieldAdapter';
import { validateRequired } from '../../../helpers/ValidatorHelper';
import DatePickerAdapter from '../../FinalFormAdapters/DatePickerAdapter';
import MfButton from '../../UI/Button/MfButton';
import {
  addressResponseToString,
  AgentPersonFormValues,
  fioValidator,
  innValidator,
  passportValidator,
  responseToForm,
  snilsValidator,
  subdivisionCodeValidator,
  submit,
  submitAddress,
} from './PersonFormUtils';
import useAccount from '../../../hooks/useAccount';
import AddressAutosuggestAdapter from '../../FinalFormAdapters/AddressAutosuggestAdapter';
import { DadataAddressResponse } from '../../../structures/response/dadata/DadataAddressResponse';
import NumberFormatAdapter from '../../NumberFormat/NumberFormatAdapter';

const PersonForm = () => {
  const { accountResponse, fetchAccountResponse } = useAccount();
  const [address, setAddress] = useState<DadataAddressResponse>();

  if (!accountResponse) {
    return null;
  }

  return (
    <Form
      initialValues={{
        ...responseToForm(accountResponse?.person),
        email: accountResponse.email,
        address: addressResponseToString(accountResponse?.addressLegal),
      }}
      onSubmit={async (values: AgentPersonFormValues) => {
        await submit(values, accountResponse?.person);
        if (address) {
          await submitAddress(address);
        }
        return fetchAccountResponse();
      }}
      render={({ handleSubmit, submitting, pristine }) => (
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Field
                label="ФИО"
                name="fio"
                component={TextFieldAdapter}
                validate={fioValidator}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                label="ИНН"
                name="inn"
                component={TextFieldAdapter}
                validate={innValidator}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                label="СНИЛС"
                name="snils"
                component={TextFieldAdapter}
                validate={snilsValidator}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                label="Серия и номер паспорта"
                name="passport"
                component={TextFieldAdapter}
                validate={passportValidator}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                label="Код подразделения"
                name="subdivisionCode"
                numberFormat="###-###"
                numberPlaceholder="___-___"
                maxLength={7}
                component={NumberFormatAdapter}
                validate={subdivisionCodeValidator}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                name="passportIssueDate"
                label="Дата выдачи"
                datePickerFormat="DD.MM.YYYY"
                animateYearScrolling
                component={DatePickerAdapter}
                validate={validateRequired}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                label="Выдан"
                name="passportIssuedBy"
                component={TextFieldAdapter}
                validate={validateRequired}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                name="bDate"
                label="Дата рождения"
                datePickerFormat="DD.MM.YYYY"
                animateYearScrolling
                component={DatePickerAdapter}
                validate={validateRequired}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                label="Место рождения"
                name="bPlace"
                component={TextFieldAdapter}
                validate={validateRequired}
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                label="Адрес регистрации"
                name="address"
                onItemSelected={(v: DadataAddressResponse) => {
                  setAddress(v);
                }}
                component={AddressAutosuggestAdapter}
                validate={validateRequired}
              />
            </Grid>
            <Grid item xs={12} sx={{ textAlign: 'right' }}>
              <MfButton
                disabled={submitting || pristine}
                type="submit"
                variant="contained"
              >
                Сохранить персональные данные
              </MfButton>
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
};

export default PersonForm;
